import { Button } from '../ui/button'
import { X } from 'lucide-react'
import { OhButton } from '../ui/custom-radix-components/button'

export default function DesktopLayout({ handleCustomize, handleAcceptAll, onClose }) {
  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-md animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div className="bg-oh-black/80 backdrop-blur-md text-white p-6 rounded-lg shadow-2xl border border-gray-700">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-lg font-semibold">Cookies Settings</h3>
          <button
            aria-label='close'
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>

        <p className="text-gray-300 text-sm mb-2 leading-relaxed">
          We use cookies on this site to enhance your user experience.
        </p>

        <p className="text-gray-300 text-sm mb-6 leading-relaxed">
          For a complete overview of all cookies used, please visit your{' '}
          <button
            onClick={handleCustomize}
            className="text-white underline hover:text-cyan-300 transition-colors"
          >
            personal settings
          </button>
          .
        </p>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            onClick={handleCustomize}
            variant="outline"
            className="flex-1 bg-white  text-oh-black hover:bg-gray-800 hover:text-white"
          >
            Customized
          </Button>
          {/* Hidden this for now  */}

          {/* <Button
            onClick={handleRejectAll}
            variant="outline"
            className="flex-1 bg-white text-oh-black hover:bg-gray-800 hover:text-white"
          >
            Reject All
          </Button> */}
          <OhButton
            onClick={handleAcceptAll}
            className="flex-1"
          >
            Accept All
          </OhButton>
        </div>
      </div>
    </div>
  )
}
